import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import { getImages } from '../../Common/const';
import UseScrollReveal from '../../Common/UseScrollReveal';
import ArrowIcon from './ArrowIcon';

const HomeVideo = () => {
    const [openMobAccordion, setOpenMobAccordion] = useState(1);
    useEffect(() => {
        const interval = setInterval(() => {
            setOpenMobAccordion(prev => (prev % 3) + 1); // Cycle through 1, 2, 3
        }, 5000);

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    const handleMobAccordion = (item) => {
        setOpenMobAccordion(item)
    }
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.autoplay = true;
            videoRef.current.muted = true;
            videoRef.current.loop = false;
            videoRef.current.controls = false;
        }
    }, []);

    const [isMobileView, setIsMobileView] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const updateView = () => {
        setIsMobileView(window.innerWidth <= 991);
    };
    const [openGrandOpening, setOpenGrandOpening] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setOpenGrandOpening(true);
        }, 5000);
        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        if (openGrandOpening) {
            setFadeIn(true);
        }
    }, [openGrandOpening]);
    useEffect(() => {
        const videoElement = videoRef.current;
        const handleVideoEnd = () => {
            videoElement.classList.add('video-fade-in');
            videoElement.play();
            setTimeout(() => {
                // videoElement.currentTime = 0;
                videoElement.classList.remove('video-fade-in');
            }, 3000);
        };
        if (videoElement) {
            videoElement.addEventListener('ended', handleVideoEnd);
        }
        return () => {
            if (videoElement) {
                videoElement.addEventListener('ended', handleVideoEnd);
            }
        };
    }, []);
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleResize();
        updateView();
        window.addEventListener('resize', handleResize, updateView);
        return () => {
            window.removeEventListener('resize', handleResize, updateView);
        };
    }, []);
    return (
        <>
            <section className='banner-main-wrap'>
                <div className="banner-wrap home-banner-wrap pt-0">
                    <div className='video-relative'>
                        {/* {isPageLoaded ? ( */}
                        {!isMobile &&
                            <video className='video-background' width="100%" ref={videoRef} muted loop playsInline autoPlay preload="auto">
                                <source src={`${getImages('banner_video.mp4')}`} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        }
                        {isMobile &&
                            <video className='video-background m-video' width="100%" ref={videoRef} muted loop playsInline autoPlay preload="auto">
                                <source src={`${getImages('banner_video.mp4')}`} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        }
                        {/* ): 
                                <img src={getImages('banner_video_img.webp')} alt='banner video'/>
                            } */}
                    </div>
                    <div className='home-overlay-pos'>
                        <div className='home-banner-pos'>
                            <div className='container'>
                                <div className='d-flex align-items-center banner-flex'>
                                    <div>
                                        <h1 className='d-none'>The Luxury Exotic Specialist</h1>
                                        <div className='hm-banner-sm-title text-uppercase wow fadeIn' data-wow-delay="2s"  data-wow-duration="4s">THE</div>
                                        <div className='hm-banner-lg-title text-uppercase text-orange wow fadeInLeft' data-wow-delay="0.2s" data-wow-duration="1s">Luxury</div>
                                        <div className='hm-banner-lg-title text-uppercase wow fadeInLeft' data-wow-delay="1.2s"  data-wow-duration="1s">Exotic</div>
                                        <div className='hm-banner-sm-title text-uppercase wow fadeIn' data-wow-delay="2s"  data-wow-duration="4s">Specialist</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='banner-bottom'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-4 my-lg-0 my-2 order-lg-2 wow reveal fadeInUp'>
                                <Link to="/cars-for-sale-florida-california" className='service-box service-mid-box d-flex align-items-center'>
                                    <div className='sb-icon me-2'>
                                        <ArrowIcon/>
                                    </div>
                                    <div className='md-title text-uppercase'>OUR INVENTORY</div>
                                </Link>
                            </div>
                            <div className='col-lg-4 my-lg-0 my-2 wow reveal fadeInUp'>
                                    <Link to="/sell-my-vehicle" className='service-box d-flex align-items-center'>
                                        <div className='sb-icon me-2'>
                                            <ArrowIcon/>
                                        </div>
                                        <div className='md-title text-uppercase'>Sell My Car</div>
                                    </Link>
                            </div>
                            <div className='col-lg-4 my-lg-0 my-2 order-lg-3 wow reveal fadeInUp'>
                                <Link to="/car-service-in-tampa-fl" state={{ openModal: true }} className='service-box d-flex align-items-center'>
                                    <div className='sb-icon me-2'>
                                        <ArrowIcon/>
                                    </div>
                                    <div className='md-title text-uppercase'>Schedule Service</div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeVideo